<template>
  <v-dialog v-model="show" max-width="800px" :persistent="persistent">
    <v-card>
      <v-card-title style="justify-content: center">{{ modalTitle }}</v-card-title>
      <v-card-text v-if="introductionSentence">{{ introductionSentence }}</v-card-text>
      <slot name="content"></slot>
      <v-card-actions class="pa-0">
        <v-btn color="secondary" tile class="ml-0" style="width: 100%" @click="close()">{{ $t('return.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'InformationDialog',

    props: {
      title: {
        type: String,
        default: undefined,
      },
      introductionSentence: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      closeOnValidate: {
        type: Boolean,
        default: true,
      },
      persistent: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle: function () {
        if (!this.title) {
          return this.$t('components.modalMultipleChoices.defaultTitle')
        } else return this.title
      },
    },
    methods: {
      validate: function () {
        this.$emit('validate')
        if (this.closeOnValidate) {
          this.show = false
        }
      },
      close: function () {
        this.$emit('close')
        this.show = false
      },
    },
  }
</script>
<style scoped>
  .w-45 {
    width: 45%;
  }
</style>
